import { Button, ButtonProps, styled } from '@mui/material';
import React from 'react';

const StyledAiButton = styled(Button)(({ theme }) => ({
  position: 'relative',
  border: '1px solid',
  borderColor: theme.palette.divider,
  overflow: 'hidden',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: '1px',
    background: 'linear-gradient(90deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #9400d3, #ff0000)',
    backgroundSize: '200% 100%',
    borderRadius: 'inherit',
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    maskComposite: 'exclude',
    animation: 'rainbow-border 4s linear infinite',
    pointerEvents: 'none',
  },

  '&:hover': {
    borderColor: theme.palette.divider,
  },

  '@keyframes rainbow-border': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '100%': {
      backgroundPosition: '200% 50%',
    },
  },
}));

export const AiButton: React.FC<ButtonProps> = (props) => {
  return <StyledAiButton {...props} />;
};

export default AiButton;
